import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { API } from "./apiutil";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CrmService {
    http;
    constructor(http) {
        this.http = http;
    }
    search(ctx) {
        return this.http.get(`${environment.base}/crm/events`, { params: API.makeParams(ctx) });
    }
    createEvent(event) {
        return this.http.post(`${environment.base}/crm/events`, event);
    }
    getCrmEvents(ctx) {
        return this.http.get(`${environment.base}/crm/events`, { params: API.makeParams(ctx) });
    }
    static ɵfac = function CrmService_Factory(t) { return new (t || CrmService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CrmService, factory: CrmService.ɵfac });
}
